// General
import "@lottiefiles/lottie-player";
import { gsap, Power3 } from 'gsap'

import { ready } from './lib/utils/utils'

// Stimulus.js and controllers
import { Application } from 'stimulus';
import ExpandableController from './lib/controllers/expandable-controller';
import NavMainSubMenuController from './lib/controllers/nav-main-sub-menu-controller';
import HeaderController from './lib/controllers/header-controller';
import SearchFieldController from './lib/controllers/search-field-controller';
import AccordionController from './lib/controllers/accordion-controller';
import AccordionItemController from './lib/controllers/accordion-item-controller';
import DisruptorController from './lib/controllers/disruptor-controller';
import KeyvisualController from './lib/controllers/keyvisual-controller';
import TimelineController from "./lib/controllers/timeline-controller";
import LottieJsonController from './lib/controllers/lottie-json.js';
import SwiperController from './lib/controllers/swiper-controller';
import HeroController from './lib/controllers/hero.js';


// Setup functions
import { SetupInViewDetection } from './lib/bootstrap/setup-in-view-detection';
import { SetupAnchorScrollTo } from './lib/bootstrap/setup-anchor-scroll-to';
import { SetupLightbox } from './lib/bootstrap/setup-lightbox';
import { SetupIsScrolledDetector } from './lib/bootstrap/setup-is-scrolled-detector';

gsap.defaults({
  ease: Power3.easeInOut,
  duration: 0.35
});

ready(function () {

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) document.body.classList.add("-is-ie-11");

  // Stimulus.js and controllers
  const application = Application.start();
  application.register('expandable', ExpandableController);
  application.register('nav-main-sub-menu', NavMainSubMenuController);
  application.register('header', HeaderController);
  application.register('search-field', SearchFieldController);
  application.register('accordion', AccordionController);
  application.register('accordion-item', AccordionItemController);
  application.register('disruptor', DisruptorController);
  application.register('keyvisual', KeyvisualController);
  application.register("timeline", TimelineController);
  application.register('lottie-json', LottieJsonController);
  application.register('swiper', SwiperController);
  application.register('hero', HeroController);


  const animationTriggers = {
    '.fx-stagger': (el) => {
      const tl = gsap.timeline({ repeat: -1, repeatDelay: 0. });
      tl.from(el.children, { opacity: 0, y: 50, stagger: 0.2, duration: 0.5 })
        .to(el.children, { opacity: 0, x: -500, stagger: 0.2, delay: 6, duration: 1 })
        .from(el.children, { opacity: 0, y: 50, stagger: 0.2, duration: 0.5 });
    }
  }
  // Setup functions
  SetupInViewDetection(animationTriggers);
  SetupAnchorScrollTo();
  SetupLightbox();
  SetupIsScrolledDetector();

});